<tt-page *ngIf="page">
    <tt-card class="col-xs-12 sp-0">
        <label *ngIf="page.page_heading > ''" class="checklist-h1e col-xs-12">{{ page.page_heading | uppercase }}</label>
        <tt-radio-button-group [ttModel]="page.bg_srchecklistcrewchange_main" (ttModelChange)="selectMode($event)">
            <tt-radio-button ttValue="SELECT" ttLabel="bg_srchecklistcrewchange_main_select"></tt-radio-button>
            <tt-radio-button ttValue="SIGNOUT" ttLabel="bg_srchecklistcrewchange_main_signout"></tt-radio-button>
            <tt-radio-button ttValue="SEARCH" ttLabel="bg_srchecklistcrewchange_main_search"></tt-radio-button>
        </tt-radio-button-group>
        <ng-container *ngIf="page.bg_srchecklistcrewchange_main === 'SELECT'">
            <tt-input ttLabel="resource_id" [ttModel]="page.resource_id" ttReadonly></tt-input>
            <tt-input ttLabel="resource_name" [ttModel]="page.resource_name" ttReadonly></tt-input>
        </ng-container>
        <tt-datetime *ngIf="page.bg_srchecklistcrewchange_main === 'SELECT' || page.bg_srchecklistcrewchange_main === 'SEARCH'" ttLabel="signin_dt" [(ttModel)]="page.signin_dt" [ttSublabel]="page.signin_dt_helptext" [ttMinutePrecision]="1"></tt-datetime>
        <ng-container *ngIf="page.bg_srchecklistcrewchange_main === 'SIGNOUT'">
            <tt-datetime ttLabel="signout_dt" [(ttModel)]="page.signout_dt" [ttSublabel]="page.signout_dt_helptext" [ttMinutePrecision]="1"></tt-datetime>
            <tt-button ttText="srchecklistcrewchange_selectall" ttIcon="fas fa-check-square" (ttClick)="selectAll()"></tt-button>
        </ng-container>
        <form *ngIf="page.bg_srchecklistcrewchange_main === 'SEARCH'" (ngSubmit)="searchCrews()">
            <tt-input ttLabel="searchtext" ttType="search" [(ttModel)]="page.searchtext" ttShowClearButton></tt-input>
            <tt-button ttText="search" ttIcon="fas fa-search" ttButtonType="submit" [ttLoading]="searching"></tt-button>
        </form>
        <tt-list [ttData]="crews" [ttGoto]="false" (ttClick)="toggleChosen($event.item)">
            <ng-template #ttListItemTemplate let-item="item">
                <button type="button" class="tt-list-item__button" (click)="toggleChosen(item)">
                    <span *ngIf="item.item_id !== '0' && item.item_id !== '-1'" class="fas" [class.fa-check-square]="item.item_is_selected === '1'" [class.fa-square]="item.item_is_selected !== '1'" aria-hidden="true"></span>
                    <span>{{ item.item_name }}</span>
                    <div>{{ item.item_name_sub1 }}</div>
                    <div>{{ item.item_name_sub2 }}</div>
                </button>
            </ng-template>
        </tt-list>
        <tt-button-save ttText="srchecklistcrewchange_save" [ttLoading]="saving" (ttClick)="saveChanges()"></tt-button-save>
    </tt-card>
</tt-page>
